<template>
    <v-chart
        class="echart"
        :option="option"
        :autoresize="autoresize"
        :loading="loading"
        :theme="theme"
        @click="onChartClick"
        @mouseover="onChartMouseover"
        @mouseout="onChartMouseout"
        @finished="onChartFinished" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
} from "echarts/components";
import VChart from "vue-echarts";

// Single project entry point for ECharts. Tree-shake by adding ONLY the
// chart types and components used in the app. When you introduce a new
// chart type (heatmap, scatter, etc.) extend this list — do not call
// `use()` from individual components.
use([
    CanvasRenderer,
    BarChart,
    LineChart,
    PieChart,
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
]);

export default {
    name: "EChart",
    components: { VChart },
    props: {
        option: { type: Object, required: true },
        autoresize: { type: Boolean, default: true },
        loading: { type: Boolean, default: false },
        theme: { type: String, default: undefined },
    },
    methods: {
        onChartClick(params) { this.$emit("chart-click", params); },
        onChartMouseover(params) { this.$emit("chart-mouseover", params); },
        onChartMouseout(params) { this.$emit("chart-mouseout", params); },
        // ECharts emite `finished` después de cada animación de render. Lo
        // exponemos como `chart-rendered` para callers que necesitan saber
        // cuando el chart es visualmente estable (p.ej. dispatch de analytics
        // o capturas post-render).
        onChartFinished() { this.$emit("chart-rendered"); },
    },
};
</script>

<style scoped lang="scss">
.echart {
    width: 100%;
    height: 100%;
}
</style>
